import SearchContainer from './SearchContainer.js'

export default {
  SearchContainer,
}
